import { ThemeProvider, Flex, Box } from "theme-ui";
import { Theme } from "../theme";
import * as Loader from "react-loader-spinner";
import { AuthorizingPage } from "../pages/AuthorizingPage";
import { useEffect, useState } from "react";
import Div100vh from "react-div-100vh";

const CardContainer = ({ children, isLoading, isMobile }) => {
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isUsingMobileBrowser = width <= 768;

  if (isMobile || isUsingMobileBrowser) {
    return (
      <Div100vh style={{ height: "100%" }}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            bg: "background",
            height: "100%",
          }}
        >
          {children}
        </Box>
      </Div100vh>
    );
  }

  return (
    <Box
      id="vital-overlay"
      className="vital-overlay"
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 3,
        py: 4,
        bg: "overlayBackdrop",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "440px",
          height: "min(650px, calc(100vh - 48px))",
          margin: "auto",
          bg: isLoading ? "transparent" : "background",
          borderRadius: "16px",
          border: isLoading ? "none" : "1px solid",
          borderColor: isLoading ? "transparent" : "border",
          boxShadow: isLoading ? "none" : "card",
          fontFamily: "body",
          fontSize: 2,
          overflow: "hidden",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

const LoadingContainer = ({
  isLoading,
  children,
  error,
  closeIframe,
  isMobile,
  onSuccess,
  onFailed,
}) => {
  return isLoading ? (
    <Flex
      sx={{
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Loader.Rings
        color="#D3D3D3"
        height={60}
        width={60}
        wrapperStyle={{ justifyContent: "center" }}
      />
    </Flex>
  ) : error ? (
    <AuthorizingPage
      device={null}
      state={"failed"}
      onClose={closeIframe}
      isMobile={isMobile}
      onSuccess={onSuccess}
      onFailed={onFailed}
      onBack={() => true}
      setFinishedConnecting={() => true}
      origin={""}
    />
  ) : (
    children
  );
};

export const Layout: React.FunctionComponent<{
  title: string;
  isLoading: boolean;
  error?: boolean;
  UIState?: "open" | "closed";
  isMobile?: boolean;
  closeIframe: () => void;
  onSuccess: (state: string, sourceName: string, sourceSlug: string) => void;
  onFailed: (state: string) => void;
}> = ({
  children,
  title,
  isLoading,
  error,
  UIState,
  closeIframe,
  isMobile,
  onSuccess,
  onFailed,
}) => {
  return (
    <ThemeProvider theme={{ ...Theme }}>
      <CardContainer isMobile={isMobile} isLoading={isLoading}>
        <LoadingContainer
          isLoading={isLoading}
          error={error}
          closeIframe={closeIframe}
          isMobile={isMobile}
          onSuccess={onSuccess}
          onFailed={onFailed}
        >
          {UIState === "open" && children}
        </LoadingContainer>
      </CardContainer>
    </ThemeProvider>
  );
};
